// extracted by mini-css-extract-plugin
export default {"DraggableCard":"bgg_a"};